import { gql } from "apollo-boost";

export const COUNT_DOWN_DATE = gql`
  query {
    countDown {
      title
      bgcolor
      datetime
      active
      datetime
      buttonColor
      buttonTitle
      productLink
    }
  }
`;
